<template>
  <div>
    <div
      class="Loader"
      v-if="(state & states.loading) && !hidden"
    ></div>

    <div class="W3S-error" v-if="state & states.error">
      <slot name="error">
        Data unavailable.
      </slot>

      <button @click="request">Retry</button>
    </div>

    <slot
      name="result"
      v-if="state & states.ready"
    ></slot>

    <div
      class="W3S-error"
      v-if="state & states.empty && !hidden"
    >
      <slot name="error">
        No results found.
      </slot>

      <button @click="request">Retry</button>
    </div>
  </div>
</template>

<script>
  import Api from '@/legacy/lib//Api';

  export default {
    props: {
      input: {
        type: Object
      },

      url: {
        type: String
      },

      model: {
        type: Function,
        default: null
      },

      hidden: {
        type: Boolean,
        default: false
      },

      response: {
        type: Object,
        default: null
      }
    },

    data: () => {
      return {
        state: 0x01,

        states: {
          loading: 0x01,
          ready: 0x02,
          error: 0x04,
          empty: 0x08
        },

        // Timeout for rerequesting when the url changes.
        rereqTimeout: null,

        // Time in milliseconds to wait before rerequesting after url changes.
        rereqTimeoutMs: 250
      }
    },

    mounted () {
      this.request ();
    },

    methods: {
      request () {
        this.state = this.states.loading;

        Api
          .get (this.url)
          .then (async (res) => {
            let json = await res.json ();

            if (json.code === 200) {
              json.body = json.body || json.payload;

              if (this.model !== null) {
                json.body = new this.model (json.body);
              }

              if (!json.body) {
                this.state = this.states.empty;
                return;
              }

              this.$emit (
                'input',
                json.body
              );

              // Allows for inspection of full result in parent components.
              this.$emit (
                'ready',
                json
              );
            }

            this.state = this.states.ready;
          })

          .catch (err => {
            if (err.status === 404) {
              this.state = this.states.empty;
            } else {
              console.log (err);
              this.state = this.states.error;
            }
          });
      }
    },

    watch: {
      url () {
        let self = this;

        this.state = self.states.loading;

        clearTimeout (this.rereqTimeout);

        this.rereqTimeout = setTimeout (() => {
          self.request ();
        }, this.rereqTimeoutMs);
      }
    }
  };
</script>

<style lang="scss">
  .Loader {
    margin: 100px auto;
  }
</style>